import styled from 'styled-components';
import { Container as MuiContainer } from '@mui/material';
export var Container = styled(MuiContainer).withConfig({
  displayName: "style__Container",
  componentId: "sc-klhtml-0"
})(["margin-top:12rem;&&{display:flex;justify-content:center;flex-direction:column;align-items:center;}"]);
export var Content = styled.div.withConfig({
  displayName: "style__Content",
  componentId: "sc-klhtml-1"
})(["display:flex;justify-content:center;flex-direction:column;align-items:center;margin-bottom:3rem;"]);
export var LogoContainer = styled.div.withConfig({
  displayName: "style__LogoContainer",
  componentId: "sc-klhtml-2"
})(["display:flex;margin-top:5rem;"]);